"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "./lib/utils.js";
const labelVariants = cva([
    "ui:flex ui:items-baseline ui:gap-1.5 ui:font-sans ui:text-base/7 ui:font-semibold ui:text-fg ui:sm:text-sm/6",
    // Label after its control: the control carries `peer`.
    "ui:peer-disabled:cursor-not-allowed ui:peer-disabled:opacity-70",
    // Label above its control, the standard layout. `peer` can only look
    // backwards, so read the next sibling instead: a disabled control, a Base UI
    // control's data-disabled, a wrapper whose direct child is disabled (Input
    // renders its <input> inside a div), or the control inside an InputGroup,
    // scoped so a disabled send button in the group doesn't count. `:has()`
    // cannot nest, so the wrapper case uses a child combinator.
    "ui:[&:has(+:disabled,+[data-disabled],+:not([data-slot=input-group])>:disabled,+*_[data-slot=input-group-control]:disabled)]:cursor-not-allowed",
    "ui:[&:has(+:disabled,+[data-disabled],+:not([data-slot=input-group])>:disabled,+*_[data-slot=input-group-control]:disabled)]:opacity-70",
    // Any other layout: mark the label itself.
    "ui:data-disabled:cursor-not-allowed ui:data-disabled:opacity-70",
]);
const Label = React.forwardRef(({ className, children, hint, ...props }, ref) => {
    if (!hint) {
        return (_jsx("label", { ref: ref, className: cn(labelVariants(), className), ...props, children: children }));
    }
    return (_jsxs("label", { ref: ref, className: cn(labelVariants(), className), ...props, children: [children, _jsx("span", { className: "ui:font-mono ui:text-micro ui:font-normal ui:text-fg-faint", children: hint === "optional" ? "Optional" : "Required" })] }));
});
Label.displayName = "Label";
export { Label };
